import merge from 'lodash/merge';

let config = {
    version: '',
    commit: '',
    env: '',
    urls: {
        security: '',
        base: '',
        document: ''
    }
};

merge(config, {
    version: process.env['VITE_VERSION'],
    commit: process.env['VITE_COMMIT_HASH'],
    env: process.env['NODE_ENV'] || 'development',
    urls: {
        security: process.env['REACT_APP_SECURITY'],
        base: process.env['REACT_APP_BASE'],
        document: process.env['REACT_APP_DOCUMENT']
    }
});

console.debug(`Created config - ${JSON.stringify(config)}`);

export default config;